export default __webpack_public_path__ + "static/media/inter.92e93e0e.png";